<template>
  <div class="mv-button" :class="btnClass">
    <div :class="typeClass">
      <button :type="htmlType" :disabled="disabled">
        <span v-if="loading" style="visibility: hidden">`</span>
        <span v-if="loading" class="dot-loader">
        </span>
        <slot v-else name="content">
          <span v-if="i18n">{{ $t(text) }}</span>
          <span v-else>{{ text }}</span>
        </slot>
      </button>
    </div>
  </div>
</template>

<script lang="ts">
import {computed, defineComponent} from "vue";

export default defineComponent({
  name: "MvButton",
  props: {
    i18n: {
      default: true
    },
    text: {
      default: ''
    },
    type: {
      default: 'round-primary',
    },
    color: {
      default: ''
    },
    htmlType: {
      default: 'button'
    },
    disabled: {
      default: false
    },
    loading: {
      default: false
    },
  },
  setup(props) {
    const typeClass = computed(() => {
      switch (props.type) {
        case 'round-black': return 'round-black-type'
        case 'round-white': return 'round-white-type'
        case 'round-primary': return 'round-primary-type'
        case 'rec': return 'rec-type'
        case 'rec-primary': return 'rec-primary-type'
        case 'rec-secondary': return 'rec-secondary-type'
        case 'rec-red': return 'rec-red-type'
        case 'toner-primary': return 'toner-primary'
        case 'toner-red': return 'toner-red'
        default: return 'round-type'
      }
    })
    const btnClass = computed(() => {
      const className = []
      if (props.disabled || props.loading) className.push('mv-button-disabled')
      return className.join(' ')
    })

    return {
      typeClass,
      btnClass,
    }
  }
})
</script>
